import React from 'react'
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import {
    UiContentWr,
    UiContentCol,
    UiTabContentWr
} from "../../components/common/UiPageElements";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import Footer from "../../components/footer/Footer";
import UiHowCampaignsWork from "../../components/common/UiHowCampaignsWork";
import IncentiveBanner from './views/IncentiveBanner';
import nyImage from "../../../../styles/img/ttny.jpg";
import nyImage2 from "../../../../styles/img/ttny-2.jpg";
import nyImage3 from "../../../../styles/img/ttny-3.jpg";
import nyImage4 from "../../../../styles/img/ttny-4.jpg";
import { UiCardTitle } from '../../components/common/UiCardTitle';
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import { TripFeatures } from './views/TripFeatures';
import { IncentivesQuickRead } from './views/QuickRead';
import { TermsConditions } from './views/TermsConditions';
import { Faq } from './views/Faq';
import UiIncentiveHistoryCard from '../../components/common/UiIncentiveHistoryCard';
import { UiSalesChainElement, UiSalesChainElementNoBgWr } from '../../components/common/UiSalesChainElements';
import { GreenRoundedTick } from '../../../../styles/img/svg/GreenRoundedTick';
import { UiTable } from '../../components/common/UiTable';
import Avatar from '../../../../styles/img/Avatar.png';
import sliderCardImage from '../../../../styles/img/slider-card.jpg';
import { TickIcon } from '../../../../styles/img/svg/TickIcon';
import { UiLeftContentRightImageBlock } from '../../components/common/UiImageBlock';
import { UiStatusBottom } from '../../components/common/UiStatusBarBottom';
import { OrangeHeartIcon } from '../../../../styles/img/svg/OrangeHeartIcon';
import { UiAccordion } from '../../components/common/UiAccordion';
import { UiAccordionSingleItem } from '../../components/common/UiAccordion';
import LeagueTableTeam from './views/LeagueTableTeam';
import { UiScrollNavWr, UiScrollNavItem } from "../../components/common/UiScrollToElements"
import TeamMemberTable from './views/TeamMemberTable';


export default function IncentivesLeagueTeam(props) {

    const TableHeaders = [
        { id: 1, th: 'Rank' },
        { id: 2, th: 'Name' },
        { id: 3, th: 'Sales' },
        { id: 4, th: 'Location' },
        { id: 5, th: 'Department' },
    ];


    const wizardData = [
        { id: 1, number: "1", title: 'Step 1', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.', status: 'active' },
        { id: 2, number: "2", title: 'Step 2', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.' },
        { id: 3, number: "3", title: 'Step 3', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.' },
        { id: 5, number: <TickIcon />, title: 'Success', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.', status: "success" },
    ];

    const termsConditions = [
        {
            id: 1,
            title: 'Trip to New York!',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
        {
            id: 2,
            title: 'How many do I need to sell?',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
        {
            id: 3,
            title: 'Duis enim bibendum dui ut fringilla suspendisse vel sed ultricies',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
       
    ]

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <IncentiveBanner
                    topText="Incentive"
                    title="Trip to NY 5 Days All Inc"
                    description="Lorem Epsum You're already working hard, enjoy various rewards you, your team and your family can enjoy."
                    sliderCardImage={sliderCardImage}
                />

                <UiBannerBottomBar
                    prevPage="Campaigns"
                    prevPageLink="/ui"
                    currentPage="Sell 15 Premium Tickets"
                    currentPageLink="/ui/incentives-pre-register"
                />

                <UiContentWr>
                    <UiTabContentWr>
                        <UiRowContainer fluid="fluid">
                            <UiScrollNavWr>
                                <UiScrollNavItem hash="About-the-campaign" hashText="About the campaign" />
                                <UiScrollNavItem hash="League-table" hashText="League table" />
                                <UiScrollNavItem hash="T-and-Cs" hashText="T&Cs" />
                                <UiScrollNavItem hash="FAQs" hashText="FAQs" />
                            </UiScrollNavWr>
                        </UiRowContainer>
                    </UiTabContentWr>
                </UiContentWr>

              

                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentCol>
                            <div className='sb-incentive-leauge-top-left-wr' id="About-the-campaign">
                                <UiLeftContentRightImageBlock
                                    image1={nyImage}
                                    image2={nyImage2}
                                    image3={nyImage3}
                                    image4={nyImage4}
                                    image5={nyImage4}
                                    image6={nyImage3}
                                >
                                   
                                    <div className='sb-incentive-leauge'>
                                        <UiAccordion items={termsConditions} defaultActiveKey/>
                                    </div>
                                                                   
                                </UiLeftContentRightImageBlock>
                                </div>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <UiContentWr >
                    <UiRowContainer fluid="fluid" className="sb-league-tabl-sec">
                        <UiCol lg="12">
                            <UiContentCol>
                                <UiSingleRow>
                                    <UiCol lg="12" xl="12">
                                        <TeamMemberTable/>
                                    </UiCol>    
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <UiContentWr id="League-table">
                    <UiRowContainer fluid="fluid" className="sb-league-tabl-sec">
                        <UiCol lg="12">
                            <UiContentCol>
                                <UiSingleRow>
                                    <UiCol lg="12" xl="12">
                                        <LeagueTableTeam/>
                                    </UiCol>    
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <IncentivesQuickRead wizardData={wizardData} leftImage={true} className="sb-ins-lg-wiz-4step" />
                <span id="T-and-Cs"></span>
                <TermsConditions />
                <span id="FAQs"></span>
                <Faq  />

                <Footer />

            </UiMainWrapper>
        </>
    )
}



